import Layout from "../Components/Reuseable/layout"
import '../Components/CSS/pagesCSS/about.css'
import Footer from '../Components/Reuseable/Footer.jsx';
import CoptRight from '../Components/Reuseable/Copyrights'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchSponsor, STATUSES } from "../redux/getReducer/getSponsorSlice"
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import Carousel from "react-bootstrap/Carousel";
import { useTranslation } from "react-i18next";
import ExNews from "../Components/Home/Components/ExNews";
import Search from "../Components/Home/Components/Search";
import Notification from "../Components/Home/Components/Notification";
import Language from "../Components/Home/Components/Language";
import DefaultImg from "../assets/default.png";
const Sponsor = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(); 
  const { data: sponsors, status } = useSelector((state) => state.sponsor);
  const cookiedata = Cookies.get("i18next");

  useEffect(() => {
    dispatch(fetchSponsor());
  }, [dispatch]);

  return (
    <>
      <div className="aboutpage">
        <div className="aboutpageheader">
          <h2>{t("sponsors")}</h2>
        </div>
        
        <div className="container mt-5 mb-5">
          {status === STATUSES.LOADING ? (
            <div style={{ textAlign: 'center', margin: '50px 0' }}>
              <p>{t("Loading...")}</p>
            </div>
          ) : (
            <div className="row">
              {sponsors && sponsors.length > 0 ? (
                sponsors.map((item, index) => (
                  <div className="col-md-3 mb-4" key={index} style={{ textAlign: "center" }}>
                    <a href={item.Url} target="_blank" rel="noreferrer">
                      <img 
                        src={item.image || DefaultImg} 
                        alt="sponsor" 
                        style={{ width: "100%", maxWidth: "200px", height: "auto", objectFit: "contain", borderRadius: "8px", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" }} 
                      />
                    </a>
                    <h5 className="mt-3">{cookiedata === "en" ? item.TitleEn : item.TitleAr}</h5>
                  </div>
                ))
              ) : (
                <div className="col-12 text-center">
                  <p>{t("No Sponsors Found")}</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      
      <Footer />
      <CoptRight />
    </>
  )
}
export default Sponsor